export default __webpack_public_path__ + "static/media/nose.0ea8522c.ogg";